document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll(
      ".feature-row__image"
    );
    images[0].classList.add('active');

    setInterval(() => {
      for (const image of images) {
        if (image.classList.contains('active')) {
          image.classList.remove('active');
          if (image.nextElementSibling) image.nextElementSibling.classList.add('active');
          else images[0].classList.add('active');
          break;
        }
      }
    }, 2000);
  });